import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a24a6250"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-metrics-bar-element" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.propertyMetrics)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.propertyMetrics, ([k, m]) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "property-metric",
            key: k
          }, _toDisplayString(m.text) + ": " + _toDisplayString(m.value), 1))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}